/** Secure launch (M29, console Settings › Secure launch). Shell created by WP-M29-SCHEMA1: later work packages add keys inside their group (en and fil together, no dots inside key segments). */
export const launch = {
  page: {
    title: "Secure launch",
    subtitle: "Ang server ninyo ang nagpapatunay sa customer. Ang browser ay may dalang one-time code lang na isang beses gumagana, mga 60 segundo.",
    unavailableTitle: "Hindi pa naka-on ang Secure launch sa workspace na ito",
    unavailableBody: "Hilingin sa Sagot na i-on ito. Pagkatapos, mapipili na ninyo kung aling mga site ang maaaring magpakita ng chat at makapag-set up ng launch mula sa sarili ninyong login.",
    loadError: "Hindi ma-load ang Secure launch.",
  },
  arrival: {
    title: "Paano dumarating ang mga customer",
    subtitle: "Bawat agent. Piliin ang agent, tapos ang mga paraan para marating ng customer ang chat nito.",
    agent: "Agent",
    agentHint: "May sariling settings ang bawat agent.",
    launchTitle: "Launch mula sa login ninyo",
    launchHint: "Tinatawag ng server ninyo ang Launch API at nire-redirect ang customer. Inirerekomenda.",
    email_codeTitle: "Email code",
    email_codeHint: "Para sa mga site na walang sariling login. Padadalhan ng code ang customer sa email.",
    open_linkTitle: "Open link, walang sign-in",
    open_linkHint: "Sinumang may link ay makakatanong ng mga pampublikong tanong. Walang account data na ipinapakita.",
    lastWayIn: "Kailangang may hindi bababa sa isang paraan na naka-on.",
    verifiedOnly: "Mga naka-sign-in na customer lang",
    stateTitle: "Itali ang link sa tab na nagsimula nito",
    stateHint: "Walang mabubuksan ang link na na-forward. May dagdag na isang redirect sa Sagot muna. Para sa lahat ng agent.",
    stateChangeTitle: "Ano ang babaguhin ng server ninyo",
    stateStep1: "Ipapadala ng Sagot ang customer sa mint URL ninyo na may isang beses na state value.",
    stateStep2: "Isa-sign in ng server ninyo ang customer gaya ng dati at tatawagin ang Launch API gamit ang parehong state.",
    stateStep3: "Sa tab lang na nagsimula nito mabubuksan ang link, kaya papalya ang link na na-forward o na-copy.",
    stateNeedsMint: "Ilagay muna ang mint URL ninyo sa Mga endpoint ninyo, kung hindi ay wala pang mapagsisimulan ang mga customer.",
    noAgentsTitle: "Wala pang agent",
    noAgentsBody: "Gumawa muna ng agent. Bawat agent ang may sariling paraan ng pagdating.",
    readOnly: "Ang mga taong may pahintulot sa Secure launch lang ang makapagbabago nito.",
    save: "I-save ang pagdating",
    saving: "Sine-save",
    discard: "Itapon ang mga pagbabago",
    saved: "Na-save ang mga paraan ng pagdating.",
  },
  urls: {
    title: "Mga endpoint ninyo",
    subtitle: "Sa mga address lang na ito pinapapunta ang mga customer ng launch.",
    statusSet: "May mint URL",
    statusNotSet: "Walang mint URL",
    mintLabel: "Mint URL (server ninyo)",
    mintHint: "Ginagamit sa state binding at para i-relaunch ang nag-expire na frame. https lang.",
    mintPlaceholder: "https://www.example.com/support/chat",
    returnLabel: "Mga pinapayagang return URL",
    returnHint: "Eksaktong address na maaaring pagbalikan ng customer ng launch, gaya ng https://www.example.com/account. Walang wildcard.",
    placeholder: "https://www.example.com/account",
    add: "Magdagdag ng address",
    empty: "Wala pang return address. Tatanggihan ang launch na humihingi ng return address hanggang hindi ninyo ito nilalagay.",
    count: "{{count}} sa {{max}}",
    remove: "Alisin ang {{address}}",
    duplicate: "Nasa listahan na ang {{address}}.",
    full: "Hanggang {{max}} address ang puwede.",
    added: "Naidagdag ang {{address}}",
    removed: "Naalis ang {{address}}",
    invalid: "Maglagay ng buong address gaya ng https://www.example.com/account.",
    invalidHttp: "https:// na address lang ang pinapayagan.",
    invalidWildcard: "Hindi pinapayagan ang wildcard. Ilista ang bawat address nang eksakto.",
    invalidCredentials: "Alisin ang user name at password sa address.",
    invalidFragment: "Alisin ang #fragment sa address.",
    invalidLength: "Masyadong mahaba ang address (hanggang 2048 character).",
    readOnly: "Ang mga taong may pahintulot sa Secure launch lang ang makapagbabago nito.",
    save: "I-save ang mga endpoint",
    saving: "Sine-save",
    discard: "Itapon ang mga pagbabago",
    saved: "Na-save ang mga endpoint.",
  },
  frame: {
    title: "Ipakita sa loob ng inyong mga page",
    subtitle: "Mga site na maaaring mag-frame ng chat. Default: wala.",
    statusOn: "Naka-on",
    statusOff: "Naka-off",
    listLabel: "Mga site na maaaring magpakita ng chat",
    hint: "Eksaktong address lang, gaya ng https://www.example.com. Walang wildcard, walang path.",
    placeholder: "https://www.example.com",
    add: "Magdagdag ng site",
    empty: "Walang pinapayagang site. Walang makakapagpakita ng chat sa sarili nilang page.",
    count: "{{count}} sa {{max}}",
    remove: "Alisin ang {{origin}}",
    duplicate: "Nasa listahan na ang {{origin}}.",
    full: "Hanggang {{max}} site lang ang maaaring ilista.",
    added: "Naidagdag ang {{origin}}",
    removed: "Naalis ang {{origin}}",
    invalid: "Maglagay ng eksaktong address gaya ng https://www.example.com.",
    invalidHttp: "Mga https:// site lang ang maaaring magpakita ng chat.",
    invalidWildcard: "Hindi pinapayagan ang wildcard. Ilista ang bawat site sa eksaktong address nito.",
    invalidPath: "Address lang ng site ang gamitin, walang path ng page.",
    invalidAddress: "Gamitin ang pangalan ng site, hindi ang IP address.",
    invalidCredentials: "Alisin ang user name at password sa address.",
    cspLead: "Magdadagdag ang site ninyo ng isang linya sa sarili nitong Content-Security-Policy:",
    cspTail: "Huwag ilagay ang chat sa mga page ng deposito at bayad.",
    sentAs: "Ipinapadala bilang frame-ancestors sa bawat chat page ng workspace na ito. Aabot sa mga bisita ang pagbabago sa loob ng isang minuto.",
    lastChanged: "Huling binago {{when}}",
    neverChanged: "Hindi pa nababago",
    save: "I-save ang mga site",
    saving: "Sine-save",
    discard: "Itapon ang mga pagbabago",
    saved: "Na-save ang mga site. Aabot sa mga bisita ang pagbabago sa loob ng isang minuto.",
    readOnly: "Ang mga taong may pahintulot sa settings lang ang makakapagbago ng listahang ito.",
    loadError: "Hindi ma-load ang mga pinapayagang site.",
    loadErrorBody: "Tingnan ang koneksyon at subukan ulit. Walang nabago.",
  },
  session: {
    title: "Mga limitasyon ng session",
    subtitle: "Hindi kailanman lalampas sa sarili ninyong login session.",
    access: "Access token",
    idle: "Idle timeout",
    absolute: "Pinakamahaba",
    minutes_one: "{{count}} minuto",
    minutes_other: "{{count}} minuto",
    hours_one: "{{count}} oras",
    hours_other: "{{count}} oras",
    limitsHint: "Access token 5 hanggang 60 minuto, idle timeout 5 hanggang 60 minuto, pinakamahaba 1 hanggang 12 oras. Para sa mga launch na gagawin pagkatapos ng pagbabago.",
    urlTokenTitle: "Payagan ang sign-in token sa mga URL",
    urlTokenHint: "Ang mas lumang portal sign-in (?sso_token= o #token=). I-off kapag live na ang mga launch.",
    readOnly: "Ang mga taong may pahintulot sa Secure launch lang ang makapagbabago nito.",
    save: "I-save ang mga limitasyon",
    saving: "Sine-save",
    discard: "Itapon ang mga pagbabago",
    saved: "Na-save ang mga limitasyon ng session.",
  },
  keys: {
    title: "Server key",
    subtitle: "Ipinapakita nang isang beses sa paggawa. Nakaimbak bilang peppered hash.",
    create: "Gumawa ng launch key",
    createDefaultName: "Launch",
    emptyTitle: "Wala pang launch key",
    emptyBody: "Gumawa ng key na may launch scope para masimulan ng inyong server ang chat ng mga naka-sign-in na customer.",
    loadError: "Hindi ma-load ang mga server key.",
    colName: "Pangalan",
    colScopes: "Mga scope",
    colAllowed: "Mga pinapayagang IP",
    colLastUsed: "Huling ginamit",
    colExpires: "Mag-e-expire",
    colActions: "Mga aksyon",
    neverUsed: "Hindi pa",
    neverExpires: "Hindi",
    anyAddress: "Kahit anong address",
    retires: "Titigil sa loob ng {{time}}",
    signed: "Naka-sign na request",
    rotate: "I-rotate",
    rotateOne: "I-rotate ang {{name}}",
    security: "Seguridad",
    securityOne: "IP allowlist at signing para sa {{name}}",
    deniedTitle: "Owner at admin ang namamahala ng mga server key",
    deniedBody: "Hilingin sa may pahintulot sa API keys na gumawa o mag-rotate ng launch key.",
    note: "Itago ang key na ito sa inyong server. Idagdag ang mga address ng inyong server para walang silbi ang nanakaw na key sa ibang lugar.",
  },
  test: {
    title: "Test launch",
    subtitle: "Sandbox lang. Gumagamit ng gawa-gawang test customer.",
    agent: "Agent",
    tier: "Tier ng customer",
    noTier: "Walang tier",
    noTiers: "Wala pang tier na naka-define sa workspace na ito.",
    plusOnly: "Kailangan ng Secure launch Plus ang customer facts.",
    status: "Status ng account",
    statuses: {
      active: "Aktibo",
      restricted: "May restriksyon",
      suspended: "Suspendido",
      self_excluded: "Self-excluded",
      closed: "Sarado",
      kyc_pending: "Naghihintay ng beripikasyon",
    },
    displayName: "Pangalan na ipapakita",
    displayNamePlaceholder: "Test Customer",
    run: "Patakbuhin ang test launch",
    runAgain: "Ulitin",
    sandboxNote: "Gagawa ng test customer na may reference na gaya ng test_ab12cd34. Lalabas ito sa audit log bilang test launch at hindi binibilang sa launch metrics.",
    noLiveTitle: "Walang live na agent na masusubukan",
    noLiveBody: "Mag-publish muna ng agent. Ang chat ng live na agent ang binubuksan ng launch.",
    resultLabel: "Ano ang dumaan sa browser",
    stepMint: "Humihingi ng launch ang server ninyo sa Sagot",
    mintNote: "Sa request body lang dumadaan ang reference ng customer.",
    stepBrowser: "Ipinapadala ang browser sa address na ito",
    browserNote: "Nasa likod ng # ang code kaya hindi ito aabot sa server log o referrer. Isang beses lang ito gumagana, mga isang minuto.",
    open: "Buksan ang chat",
    copyLink: "I-copy ang link",
    nothingPersonal: "Nasuri: wala sa address na ito ang reference ng test customer.",
    stepRedeem: "Ginagamit ng chat page ang code",
    status_issued: "Naghihintay",
    status_redeemed: "Nagamit na",
    status_expired: "Nag-expire",
    status_revoked: "Binawi",
    waiting_one: "Naghihintay na mabuksan ang link. {{count}} segundo na lang.",
    waiting_other: "Naghihintay na mabuksan ang link. {{count}} segundo na lang.",
    waitingEnding: "Malapit nang mag-expire ang code.",
    expiredUnused: "Nag-expire ang code bago may nagbukas nito. Ulitin ang test.",
    revoked: "Tinapos ang launch na ito bago nagamit.",
    redeemedAt: "Nagamit {{when}} mula sa {{origin}}.",
    originUnknown: "hindi kilalang origin",
    redeemBody: "Ang ipinadala ng chat page",
    stepSession: "Magbubukas ang session",
    sessionPending: "Lalabas dito ang session kapag nagamit na ang code.",
    sessionAccess: "Valid ang access token hanggang",
    sessionIdle: "Matatapos pagkatapos ng",
    sessionIdleValue_one: "{{count}} minutong walang aktibidad",
    sessionIdleValue_other: "{{count}} minutong walang aktibidad",
    sessionMax: "Matatapos nang hindi lalampas sa",
    statusError: "Hindi ma-check ang status ng test. Ulitin ang test.",
  },
  errors: {},
  tier: {
    title: "Ang inyong Secure launch",
    subtitle_lite: "Sina-sign in ng Lite ang mga customer at pinapangalanan sila sa chat. Kailangan ng Plus ang customer facts.",
    subtitle_plus: "Sina-sign in ng Plus ang mga customer at ginagamit ang alam ninyo tungkol sa kanila.",
    name_none: "Hindi kasama",
    name_lite: "Lite",
    name_plus: "Plus",
    usageLabel: "Mga launch ngayong buwan",
    resets: "Magbibilang muli simula {{date}} (oras sa Maynila).",
    usedUp: "Naubos na ang mga launch ngayong buwan. Tatanggihan ang mga bagong launch hanggang {{date}}. Patuloy na makakapag-chat ang mga customer na naka-sign in na.",
    almostUsed_one: "{{count}} launch na lang ang natitira ngayong buwan. Magsisimula muli ang bilang sa {{date}}.",
    almostUsed_other: "{{count}} launch na lang ang natitira ngayong buwan. Magsisimula muli ang bilang sa {{date}}.",
    unlimited: "Walang limitasyon ang launch. Naka-on ang customer facts.",
    includesLabel: "Ano ang kasama sa inyong Secure launch",
    included: "Kasama",
    notIncluded: "Hindi kasama",
    lineLaunch: "Launch na naka-sign-in na may one-time code, limitasyon ng session at revoke",
    lineNamed: "\"Chatting as\" ang customer, magkakasama ang mga chat ayon sa customer reference",
    lineFacts: "Customer facts (tier, katayuan ng account, attribute) na ginagamit ng AI, mga flow at routing",
    promptTitle: "Kailangan ng Secure launch Plus ang customer facts",
    promptBody: "Tinatanggihan ang launch na may tier, katayuan ng account o mga attribute (403 secure_launch_plus_required), at hindi ipinapakita sa AI o ginagamit ng mga flow at routing ang facts na naka-store na. I-upgrade sa Plus para magamit ang mga ito. Walang limitasyon ang Plus at pinapalitan nito ang Lite.",
    upgrade: "I-upgrade sa Plus",
    askOwner: "Hilingin sa owner o admin ng workspace na mag-upgrade sa Secure launch Plus.",
  },
  upsell: {
    title: "I-sign in ang mga customer mula sa sarili ninyong login",
    badge: "Add-on",
    body: "Hinahayaan ng Secure launch ang sarili ninyong server na magpatunay sa naka-sign-in na customer, kaya bukas na ang chat na naka-sign-in na may tier at status ng customer na iyon.",
    pointVouch: "Ang server ninyo ang nagpapatunay sa customer. Walang magta-type ng code o password.",
    pointCode: "Isang beses na code lang ang dala ng browser, gumagana nang mga isang minuto.",
    pointTest: "Piliin kung paano dumarating ang mga customer, itakda ang limitasyon ng session at subukan muna sa test launch bago mag-go-live.",
    plans: "Kasama sa Institution plan. Sa Standard at Pro, add-on ito.",
    addAddon: "Idagdag ang Secure launch",
    talkToSales: "Makipag-usap sa sales",
    salesSubject: "Secure launch add-on",
    askOwner: "Hilingin sa owner o admin ng workspace na idagdag ang Secure launch.",
  },
  oidc: {
    title: "Mag-sign in gamit ang OpenID provider ninyo",
    subtitle: "Kung may OpenID Connect provider na ang kumpanya ninyo, puwedeng dumaan doon ang mga customer. Bubukas ang chat na naka-sign-in na ang customer, tier at status na sinasabi ng provider ninyo.",
    statusNotSet: "Hindi pa naka-set up",
    statusOn: "Naka-on",
    statusOff: "Naka-off",
    issuerLabel: "Issuer",
    issuerHint: "Ang https address ng provider ninyo. Doon binabasa ng Sagot ang discovery document nito.",
    issuerPlaceholder: "https://login.your-company.com",
    clientIdLabel: "Client ID",
    secretLabel: "Client secret",
    secretHint: "Mula sa provider ninyo. Nakasara ito sa Sagot at hindi na ipapakita ulit.",
    secretStored: "May nakatabing secret. Iwanang walang laman para panatilihin ito.",
    secretKeep: "Nakatabi",
    scopesLabel: "Dagdag na scope",
    scopesHint: "Paghiwalayin ng espasyo. Laging hinihingi ang openid. Hanggang {{max}} lahat.",
    mappingTitle: "Aling mga claim ang naglalarawan sa customer",
    mappingHint: "Mga pangalan ng claim sa ID token. Ang tier na hindi tinukoy ng workspace ninyo, o status na hindi kilala ng Sagot, ay hindi isasama at makakapag-sign in pa rin ang customer.",
    mapRef: "Claim ng customer reference",
    mapTier: "Claim ng tier",
    mapStatus: "Claim ng account status",
    activeTitle: "Ialok ang sign-in na ito",
    activeHint: "I-off para itago ang button nang hindi nawawala ang mga setting.",
    addressesTitle: "Mga address para sa provider ninyo",
    addressesHint: "Irehistro ang address na babalikan pagkatapos mag-sign in sa provider ninyo, isa bawat agent. I-link ang site ninyo sa start address.",
    addressesEmpty: "Wala pang live na agent. I-publish ang isang agent para makuha ang mga address nito.",
    redirectLabel: "Irehistro ang redirect address na ito",
    startLabel: "Start address (dito i-link ang mga customer)",
    copy: "Kopyahin",
    frameNote: "Sa loob ng frame, hindi maipapakita ang provider, kaya bumabalik ang chat sa launch code doon. Gamitin ang sarili ninyong login para mag-mint ng launch para sa naka-embed na chat.",
    readOnly: "Mababasa ninyo ang mga setting na ito. Hilingin sa owner o admin ng workspace na baguhin ang mga ito.",
    discard: "Itapon",
    save: "I-save",
    saving: "Sine-save…",
    saved: "Na-save ang OpenID sign-in.",
    loadError: "Hindi ma-load ang mga setting ng OpenID sign-in.",
    problemIssuerInvalid: "Ilagay ang address ng provider ninyo, na nagsisimula sa https://.",
    problemIssuerHttp: "Dapat magsimula sa https:// ang issuer.",
    problemClientId: "Ilagay ang client ID mula sa provider ninyo.",
    problemSecret: "Ilagay ang client secret mula sa provider ninyo.",
    problemScopes: "Sobra ang dami ng scope.",
    problemMapping: "Maglagay ng claim para sa bawat isa sa tatlo.",
  },
};
